import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type VideosHeaderProps = {
  hasOptions?: boolean;
  isAdminView?: boolean;
};

const VideosHeader: FC<VideosHeaderProps> = ({
  hasOptions = true,
  isAdminView = false,
}) => {
  const { t } = useTranslate();

  return (
    <div className="nk-files-head">
      <div className="nk-file-item">
        <div className="nk-file-info">
          <span>{t('Name') || 'Name'}</span>
        </div>
        <div className="nk-file-members">
          <span>{t('Date') || 'Date'}</span>
        </div>
        {hasOptions && isAdminView && <div className="nk-file-meta" />}
      </div>
    </div>
  );
};

export default VideosHeader;

